<template src="./index.html"></template>
<script>
import {Switch, Toast} from 'vant';
import SelfConfirm from '@/components/SelfConfirm';
export default {
  name:"SetCustomerInfo",
  components:{VantSwitch:Switch,SelfConfirm},
  data(){
    return{
      name: '',
      ww_nick: '',
      star_mark: false,
      black_list: false,
      ShowSelfConfirm: false,
      contentShow: false,
    }
  },
  mounted(){
    this.getDataSet()
  },
  methods:{
    getDataSet(){
      let params = {
        ww_nick: this.$route.query.ww_nick,
        source: this.$route.query.source,
        buyer_openuid: this.$route.query.buyer_openuid,
      }
      this.$store.dispatch("CustomerInfo/getDataSet",params).then(res=>{
        this.star_mark = res.data.star_mark==1;
        this.black_list = res.data.black_list==1;
        this.name = res.data.name;
        this.ww_nick = res.data.ww_nick;
        this.contentShow = true
      })
    },
    set_starmarkSwitch(value){
      this.$store.dispatch("CustomerInfo/starmarkSwitch",{star_mark: value?1:0, ww_nick:this.$route.query.ww_nick,buyer_openuid:this.$route.query.buyer_openuid}).then(res=>{
        if(res.code != 1000){ // 失败时恢复原位
          this.star_mark = !value
        }else {
          Toast('设置成功')
          // 清空通讯录的数据，让通讯录重新请求
          this.$store.commit("AddressBook/SET_DATA", {
            key: "getTableData",
            data: [],
          });
          this.$store.commit("AddressBook/SET_DATA", {
            key: "starMarkList",
            data: [],
          });
          this.$store.commit("AddressBook/SET_DATA", {
            key: "noStarMarkList",
            data: [],
          });
          this.$store.commit("AddressBook/SET_DATA", {
            key: "AddressOffset",
            data: 0,
          });
        }
      })
    },
    set_black_list(value){
      this.$store.dispatch('Public/inH5Record',{btn_name:'资料设置页-加入黑名单开关'}).then((res)=>{
        this.$store.dispatch("CustomerInfo/blacklistSwitch",{black_list: value?1:0, ww_nick:this.$route.query.ww_nick,buyer_openuid:this.$route.query.buyer_openuid}).then(res=>{
          if(res.code != 1000){ // 失败时恢复原位
            this.black_list = !value
          }else {
            Toast('设置成功')
          }
        })
      })
    },
    setRemark(){
      this.$store.dispatch('Public/inH5Record',{btn_name:'资料设置页-设置备注和描述'}).then((res)=>{
        this.$router.push({
          path:'/SetRemark',
          query: {source: this.$route.query.source, ww_nick: this.$route.query.ww_nick,buyer_openuid: this.$route.query.buyer_openuid}
        })
      })
    },
    setLabel(){
      this.$store.dispatch('Public/inH5Record',{btn_name:'资料设置页-设置标签'}).then((res)=>{
        this.$router.push({ 
          path:'DetailsLabelPage', 
          query: {
            source: this.$route.query.source, 
            ww_nick: this.$route.query.ww_nick,
            buyer_openuid: this.$route.query.buyer_openuid
          }
        })
      })
    },
    delCustomerInfo(){
      this.$store.dispatch('Public/inH5Record',{btn_name:'资料设置页-删除按钮'})
      this.ShowSelfConfirm = true
    },
    CancelSelfConfirm(){
      this.ShowSelfConfirm = false
    },
    ConfirmSelfConfirm(){
      this.CancelSelfConfirm()
      let params = {
        is_delete:1,
        ww_nick:this.$route.query.ww_nick,
        buyer_openuid:this.$route.query.buyer_openuid
      }
      this.$store.dispatch('CustomerInfo/delCustomerInfo',params).then(res=>{
        if(res.code == 1000){
          let path = ''
          if(this.$route.query.source == 1){
            path = 'CustomerMessage'
          }else if(this.$route.query.source == 2){
            path = 'AddressBook'
          }else if(this.$route.query.source == 3){
            path = 'CustomerWarn'
          }
          sessionStorage.setItem('reload_one','1');
          this.$router.replace({ path});
        }
      })
    },
  },
}
</script>
<style src="./index.scss" lang="scss" scoped></style>